import { Navigate, Route, Routes } from "react-router-dom";

import PaymentsActivityPage from "./pages/PaymentsActivityPage";

/** Sub-router for `/app/payments-activity/*`. */
export const PaymentsActivityNavigation = () => {
  return (
    <Routes>
      <Route index element={<PaymentsActivityPage />} />
      <Route path="*" element={<Navigate to="/app/payments-activity" replace />} />
    </Routes>
  );
};
